import React, { useRef } from 'react';
import { Icon } from '@iconify/react';
import { useThreeFiberViewer } from './useThreeFiberViewer';

export const FiberViewer3D = ({ modelPath, options }) => {
    const canvasRef = useRef(null);
    const { loading, error } = useThreeFiberViewer(canvasRef, modelPath, {
        hdrPath: '/assets/hdr/studio_small_09_1k.hdr',
        autoOrbit: true,
        orbitRadius: 6,
        orbitHeight: 2,
        background: null,
        exposure: 1.0,
        useOrbitControls: true, // activar controles por defecto
        ...(options || {}),
    });

    return (
        <div className="gallery__3d-container">
            <canvas ref={canvasRef} className="gallery__3d-model" />
            {loading && (
                <div className="gallery__loading">
                    <Icon icon="bi:arrow-clockwise" className="loading__icon" />
                    <span>Cargando modelo 3D...</span>
                </div>
            )}
            {error && <div className="gallery__error">No se pudo cargar el modelo.</div>}
        </div>
    );
};
